import React from 'react';

interface EmblemProps {
    icon: any;
    name: string;
}

const Emblem: React.FC<EmblemProps> = ({ icon, name }) => {
    return (
       <div className="max-w-[128px] max-[576px]:max-w-[92px]">
            <div className="flex items-center justify-center w-[128px] h-[128px] max-[576px]:w-[92px] max-[576px]:h-[92px] bg-contain bg-center bg-no-repeat rounded-full shadow-[0_10px_20px_0_#00000026]" 
            style={{
                backgroundColor: "#fff", 
                backgroundImage: "url('/bg/emblem-bg.svg')", 
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat"
            }}
            >

            <img className='w-[58px] h-fit max-[576px]:w-[40px]' src={icon} alt="emblem" />
            </div> 
            <p className="text-center mt-4 uppercase text-black	font-bold leading-[125%]  max-[576px]:text-[10px] max-[576px]:mt-[12px]">
                {name}
            </p> 
       </div>
    )
}

export default Emblem